import { Component, ElementRef, input, output, viewChild } from '@angular/core';

export interface ConfirmationOptions {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  destructive?: boolean;
}

@Component({
  selector: 'app-confirmation-dialog',
  standalone: true,
  templateUrl: './confirmation-dialog.component.html',
})
export class ConfirmationDialogComponent {
  readonly options = input.required<ConfirmationOptions>();
  readonly decided = output<boolean>();
  private readonly dialog = viewChild<ElementRef<HTMLDialogElement>>('dialog');

  open(): void {
    this.dialog()!.nativeElement.showModal();
  }

  close(): void {
    this.dialog()?.nativeElement.close();
  }
}
